import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    connectWith: String,
    handleSelector: String,
    customUpdateEvent: String,
    axis: String,
    // Optional CSS selector limiting which direct children are sortable.
    // Without it, jQuery UI treats every direct child as draggable, which
    // makes inline "Add" buttons inside the container get caught in the
    // sortable set. Pass e.g. ".fields" (nested_form's per-row wrapper) to
    // exclude controls that share the same parent.
    itemsSelector: String
  }

  connect() {
    this.setup()
  }

  disconnect() {
    this.cleanUp()
  }

  setup() {
    $(this.element).sortable(this.buildConfig())
  }

  cleanUp() {
    $(this.element).sortable('destroy')
  }

  reset() {
    this.cleanUp()
    this.setup()
  }

  forEachTooltip(callback) {
    if (!bootstrap?.Tooltip) return

    this.element.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
      const tooltip = bootstrap.Tooltip.getInstance(el)
      if (tooltip) return callback(tooltip)
    })
  }

  buildConfig() {
    const config = {
      cursor: 'grabbing',
      placeholder: 'ui-state-highlight',
      tolerance: 'pointer',
      start: function(event, ui) {
        this.forEachTooltip(tooltip => (tooltip.hide(), tooltip.disable()))
      }.bind(this),
      stop: function(event, ui) {
        this.forEachTooltip(tooltip => tooltip.enable())
      }.bind(this),
      update: function( event, ui ) {
        if (this.hasCustomUpdateEventValue) {
          this.dispatch(this.customUpdateEventValue, { details: { event, ui } })
        } else {
          this.dispatch("update", { details: { event, ui } })
        }
      }.bind(this)
    }
    if (this.hasConnectWithValue) {
      config.connectWith = this.connectWithValue
    }
    if (this.hasHandleSelectorValue) {
      config.handle = this.handleSelectorValue
    }
    if (this.hasAxisValue) {
      config.axis = this.axisValue
    }
    if (this.hasItemsSelectorValue) {
      config.items = this.itemsSelectorValue
    }
    return config
  }
}
